var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"snapwidget-widget",staticStyle:{"border":"none","overflow":"hidden","width":"100%","height":"450px"},attrs:{"src":"https://snapwidget.com/embed/959861","allowtransparency":"true","frameborder":"0","scrolling":"no"}})}
var staticRenderFns = []

export { render, staticRenderFns }